export default __webpack_public_path__ + "static/media/work_regulation_chart_flow.a94d23ee.png";